import { useTranslation } from 'react-i18next'

import { ComboBox, Divider, Text } from '@reveni-io/reveni-ui'

import { buyXGetYOptions } from './constants'
import * as Styles from './styles'

const BuyXGetYConfiguration = ({ buyXGetYReturnPolicy, setBuyXGetYReturnPolicy, disabled }) => {
  const { t } = useTranslation()

  const handleChangeReturnPolicy = event => setBuyXGetYReturnPolicy(event.target.value)

  if (!buyXGetYReturnPolicy) return null

  return (
    <Styles.Container>
      <Divider />
      <Text type="titleM">{t('Compra X Obtén Y')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define si tus clientes pueden devolver los productos comprados con descuentos "Compra X Obtén Y" por separado o en conjunto. Si es en conjunto, se tendrán que validar todos los productos de la promoción devuelta como una sola unidad.'
        )}
      </Text>
      <ComboBox
        label={t('Devolución de descuentos Compra X Obtén Y')}
        menuItems={buyXGetYOptions.map(o => ({ ...o, label: t(o.label) }))}
        handleChange={handleChangeReturnPolicy}
        value={buyXGetYReturnPolicy}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default BuyXGetYConfiguration
